import { Checkbox, FormControl, FormControlLabel, FormGroup, FormLabel, TextField } from "@mui/material";
import { CommerceHubSettings } from "../../api";
import { PasswordField } from "../controls";

export interface CommerceHubSettingsControlProps {
  settings?: CommerceHubSettings;
  onChange: (settings: Partial<CommerceHubSettings>) => void;
}

export const CommerceHubSettingsControl = (props: CommerceHubSettingsControlProps) => {
  const { settings, onChange } = props;

  return (
    <FormControl component="fieldset" sx={{ minWidth: 150 }}>
      <FormLabel component="legend">CommerceHub settings</FormLabel>
      <FormGroup>
        <TextField label="Email" required variant="standard" value={settings?.email ?? ""} onChange={(e) => onChange({ email: e.target.value })} />
        <PasswordField label="Password" variant="standard" value={settings?.password ?? ""} onChange={(e) => onChange({ password: e.target.value })} />
        <TextField label="Profile" variant="standard" value={settings?.profile ?? ""} onChange={(e) => onChange({ profile: e.target.value })} />
        <FormControlLabel label="Sandbox" control={<Checkbox checked={settings?.sandbox ?? false} onChange={(e, c) => onChange({ sandbox: c })} />} />
      </FormGroup>
    </FormControl>
  );
};
